// extracted by mini-css-extract-plugin
export default {"color-concrete":"#F2F2F2","colorConcrete":"#F2F2F2","medium":"only screen and (min-width: 768px)","tabSwitcher":"S6mDw","overflowContainer":"bH1Jb","tabs":"UKAMw"};